import React, { Component } from 'react'
import styled from 'styled-components'
import { getTheme } from 'helpers'

export default class extends Component {
  render () {
    const { iconSrc, title, style } = this.props
    return (
      <Container style={style}>
        {iconSrc && <div><Icon src={iconSrc} /></div>}
        <Title>{title}</Title>
      </Container>
    )
  }
}

const Container = styled.section`
  border: 1px solid ${getTheme`colorBorder`};
  padding: 25px 0px;
  margin-bottom: 10px;
  text-align: center;
`
const Icon = styled.img`
  display: block;
  margin: 0 auto 10px;
`
const Title = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 25px;
  color: ${getTheme`colorBorder`};
`



// WEBPACK FOOTER //
// ./src/components/NoData.js